module.exports = __webpack_public_path__ + "src/images/products/allAmerican/78_Straight Fit Jeans.png";